import React, { useState, useContext, useEffect } from "react";
import Files from "react-files";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Button } from "@material-ui/core";
import { HOST_URL } from "../../../../../Config";
import { StoreContext } from "../../../../../Store/Provider";
import { getUserData, localStoragekey } from "../../../../Common/Utility/Utils";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import axios from "axios";
import DocumentSVG from "../../../../SVG/DocumentSVG";
import NotificationManager from "react-notifications/lib/NotificationManager";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50rem",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  borderRadius: "1rem",
  p: 2
};

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function DocumentComponent() {
  const [modalOpen, setModalOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState("");
  const handleOpen = () => setModalOpen(true);
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const [documentsData, setDocumentsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitLoadig, setSubmitLoading] = useState(false);
  const context = useContext(StoreContext);
  const [fileType, setFileType] = useState("");
  const [fileTypeList, setFileTypeList] = useState([]);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (context.shipmentNo !== "") {
      getDocumentsData();
    }
  }, [context.shipmentNo]);

  useEffect(() => {
    getFileType();
  }, []);
  const getFileType = async () => {
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`
    };
    const URL = `${HOST_URL}api/v1/Shipment/DOCUMENTTYPE`;
    axios
      .post(URL, {
        headers: header
      })
      .then((res) => {
        setFileTypeList(res.data.Value);
        setFileType(res.data.Value[0]?.Code);
      })
      .catch((err) => {
        console.log(err);
        setOpen(true);
        setSeverity("error");
        setAlertText("Failed to load document type List!");
      });
  };

  const getDocumentsData = async () => {
    setLoading(true);
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`
    };
    const body = {
      companyCode: userData.orgs,
      countryCode: "",
      shipmentid: context.shipmentNo
    };
    const URL = `${HOST_URL}api/v1/Shipment/DOCUMENT`;
    axios
      .post(URL, body, {
        headers: header
      })
      .then((res) => {
        setLoading(false);
        console.log(res);
        setDocumentsData(res.data.Value);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        setSeverity("error");
        setOpen(true);
        setAlertText("Something went wrong!");
      });
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setFileError("");
    setFiles([]);
    setModalOpen(false);
  };
  const onFilesChange = (files) => {
    setFiles(files);
    files.length !== 0 && setFileError("");
  };
  const onFilesError = (error, file) => {
    // console.log('error code ' + error.code + ': ' + error.message);
    setFileError(`Error code ${error.code} : ${error.message}.`);
  };

  const submitDoc = async () => {
    setSubmitLoading(true);
    setFileError("");
    const getBase64 = async (file, onLoadCallback) => {
      return await new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    };
    var promise = getBase64(files[0]);
    console.log(promise);
    let body = {};
    promise.then(async function (result) {
      let data = result.split(";base64,")[1];
      body = {
        FileName: files[0].name,
        ImageData: data
      };

      let userData = {};
      await getUserData(localStoragekey)
        .then((res) => {
          userData = res;
        })
        .catch((err) => {
          userData = {};
        });
      const header = {
        Authorization: `Bearer ${userData.access_token}`,
        username: `${userData.userName}`,
        grant_type: "password",
        password: `${userData.userSecret}`
      };
      const URL = `${HOST_URL}api/v1/Document/PDF/SendCWeDocDocument/${fileType}/${context.shipmentNo}`;
      console.log(URL, body);
      axios
        .post(URL, body, {
          headers: header
        })
        .then((res) => {
          console.log(res);
          setSubmitLoading(false);
          handleCloseModal();
          if (res?.data?.Success) {
            NotificationManager.success(res?.data?.ResultMessage, "", 3000);
          } else {
            NotificationManager.error(res?.data?.ResultMessage, "", 3000);
          }
        })
        .catch((err) => {
          console.log(err);
          setSubmitLoading(false);
          handleCloseModal();
          setOpen(true);
          setSeverity("error");
          setAlertText("Something went wrong!");
        });
    });
  };

  return (
    <div className="sidebarDataSection container-fluid documentSection">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
      {loading ? (
        <div
          className="loadingClass"
          style={{ height: "calc(100% - 4.75rem)" }}
        >
          <CircularProgress />
        </div>
      ) : documentsData.length === 0 ? (
        <>
          <p className="nosidebarDataPara">No documents available!</p>
        </>
      ) : (
        documentsData.map((element) => {
          return (
            <a
              className="documentAnchor"
              href={`data:application/pdf;base64,${element.ImageData}`}
              download={element.FullName}
              name={element.FullName}
            >
              <div className="documentCardBody">
                <DocumentSVG colorCode={"rgba(var(--text-heading-light))"} />
                <div className="documentNameDate">
                  <p title={element.FullName}>{element.FullName}</p>
                  <p title={element.TypeName}>{element.TypeName}</p>
                  <span>{moment(element.SaveDate).format("DD/MM/YYYY")}</span>
                </div>
              </div>
            </a>
          );
        })
      )}
      <div className="uploadDocButtonDiv">
        <Button
          variant="contained"
          className="uploadDocButton"
          onClick={handleOpen}
        >
          Upload Documents
        </Button>
      </div>
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box sx={style} className="advSearchModalContainer">
          <div className="advSearchModalContainerHeading mb-3">
            <h5>Upload Documents</h5>
            <CloseIcon className="pointer" onClick={handleCloseModal} />
          </div>
          <p className="text-danger">{fileError}</p>
          <div className="uploadDoxDivContainer">
            {files.length === 0 ? (
              <div className="files">
                <div className="row">
                  <div className="col-6">
                    <select
                      className="form-control"
                      onChange={(e) => setFileType(e.target.value)}
                      vaue={fileType}
                    >
                      {fileTypeList.map((ele, index) => {
                        return (
                          <option
                            key={index}
                            value={ele.Code}
                            label={`${ele.Description} (${ele.Code})`}
                          />
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-6" style={{ height: "100%" }}>
                    <Files
                      className="files-dropzone"
                      dragActiveClassName="files-dropzone-active"
                      onChange={onFilesChange}
                      onError={onFilesError}
                      accepts={[
                        "image/*",
                        ".pdf",
                        ".xls",
                        ".xlsx",
                        ".csv",
                        ".html",
                        ".eml",
                        ".msg"
                      ]}
                      maxFileSize={10000000}
                      minFileSize={0}
                      clickable
                      multiple={false}
                    >
                      <AddIcon />
                      Drop files here or click to upload
                    </Files>
                  </div>
                </div>
              </div>
            ) : (
              <div className="container-fluid">
                <div className="row">
                  {files.map((items) => {
                    return (
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className={`uploadDoc ${items.id}`} key={items.id}>
                          <DocumentSVG
                            colorCode={"rgba(var(--text-heading-light))"}
                          />
                          <p title={items.name}>{items.name}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="modalFooter mt-3">
                  <Button variant="contained" onClick={() => setFiles([])}>
                    Clear
                  </Button>
                  <Button variant="contained" onClick={submitDoc}>
                    {submitLoadig ? (
                      <CircularProgress
                        style={{ color: "#fff" }}
                        size="1.5rem"
                      />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default DocumentComponent;
